// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","477":"LogoMakerGuestLazyComponent"}[chunkId] + "." + {"46":"e20c5a7ef4c5e717c679","477":"999ec29a139752b6316b"}[chunkId] + ".js";
};